import React from "react";


// =============================================================================
// COMPONENT
// =============================================================================

export default function TraceabilityKPISection({

  kpis = {}

}) {

  const cards = [

    {
      label: "Planned Qty",
      value: kpis.planned_qty || 0,
      color: "#2563eb",
      icon: "📘"
    },

    {
      label: "Reserved Qty",
      value: kpis.reserved_qty || 0,
      color: "#4f46e5",
      icon: "📦"
    },

    {
      label: "Dispatched Qty",
      value: kpis.dispatched_qty || 0,
      color: "#0891b2",
      icon: "🚚"
    },

    {
      label: "Received Qty",
      value: kpis.received_qty || 0,
      color: "#ea580c",
      icon: "📥"
    },

    {
      label: "Reconciled Qty",
      value: kpis.reconciled_qty || 0,
      color: "#16a34a",
      icon: "✔"
    },

    {
      label: "Pending Dispatch",
      value: kpis.pending_dispatch_qty || 0,
      color: "#ca8a04",
      icon: "⏳"
    },

    {
      label: "Pending Receipt",
      value: kpis.pending_receipt_qty || 0,
      color: "#dc2626",
      icon: "📭"
    },

    {
      label: "Pending Reconciliation",
      value:
        kpis.pending_reconciliation_qty || 0,
      color: "#7c3aed",
      icon: "🧾"
    }
  ];


  return (

    <div style={styles.grid}>


      {

        cards.map((card) => (

          <div
            key={card.label}
            style={{
              ...styles.card,

              borderTop:
                `4px solid ${card.color}`
            }}
          >

            <div>

              <div style={styles.label}>

                {card.label}

              </div>

              <div style={styles.value}>

                {card.value}

              </div>

            </div>


            <div style={styles.icon}>

              {card.icon}

            </div>

          </div>
        ))
      }

    </div>
  );
}


// =============================================================================
// STYLES
// =============================================================================

const styles = {

  grid: {

    display: "grid",

    gridTemplateColumns:
      "repeat(auto-fit, minmax(220px, 1fr))",

    gap: 16,

    marginBottom: 20
  },

  card: {

    background: "#ffffff",

    borderRadius: 14,

    padding: 18,

    display: "flex",

    justifyContent: "space-between",

    alignItems: "center",

    boxShadow:
      "0 1px 4px rgba(0,0,0,0.08)"
  },

  label: {

    fontSize: 13,

    color: "#6b7280",

    marginBottom: 8
  },

  value: {

    fontSize: 30,

    fontWeight: 700,

    color: "#111827"
  },

  icon: {

    fontSize: 28
  }
};